/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPnnBuilderLane.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/pnn-builder-lane";

export class AutogenModelPnnBuilderLane<RowType extends ModelRow> extends Endpoint<RowType, RowPnnBuilderLaneFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPnnBuilderLane extends ModelRow<RowPnnBuilderLaneFields> {
	constructor(values?: Partial<RowPnnBuilderLaneFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPnnBuilderLaneFields {
	builder_profile_date: Date;
	builder_profile_id: string;
	company_id: string;
	destination: string;
	destination_exclude: string;
	destination_type: string;
	equipment_type: string;
	id: string;
	lane_number: number;
	lane_type: string;
	master_id: string;
	master_type: string;
	origin: string;
	origin_exclude: string;
	origin_type: string;
	reply_to_users: string;
}

